import React from "react";

export const VerticalNavigationContext = React.createContext({
  collapse: true,
  rootClassName: ""
});

export const useVerticalNavigationContext = () =>
  React.useContext(VerticalNavigationContext);
